module.exports = __webpack_public_path__ + "img/CS.16baeb19.png";